module.exports = __webpack_public_path__ + "static/media/chronic Relaps.891eaad4.svg";